import get from 'lodash/get';
import { useCallback, useEffect, useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

export type SetValueProps = Partial<{
  shouldValidate: boolean;
  shouldDirty: boolean;
  shouldTouch: boolean;
}>;

export function useFormFieldContext<T = any>(name: string) {
  const form = useFormContext();
  const {
    trigger,
    formState: { dirtyFields, errors },
  } = form;
  const register = (...args: Parameters<typeof form.register>) => {
    const { ref: innerRef, ...rest } = { ...form?.register(...args) };
    return { ...rest, innerRef };
  };

  // TODO CCRA-37242
  const isDirty = useMemo<boolean>(() => {
    return get(dirtyFields, name) ?? false;
  }, [name, dirtyFields[name]]);

  // TODO CCRA-37242
  const isError = useMemo<boolean>(() => {
    return !!get(errors, name);
  }, [name, errors[name]]);

  // TODO CCRA-37242
  const isValid = useMemo<boolean>(() => {
    return isDirty && !isError;
  }, [name, isDirty, isError]);

  // TODO CCRA-37242
  const isNotValid = useMemo<boolean>(() => {
    return isDirty && isError;
  }, [name, isDirty, isError]);

  // TODO CCRA-37242
  const setValue = useCallback(
    (newValue: T, options: SetValueProps = {}) => {
      form.setValue(name, newValue, options);
    },
    [form.setValue]
  );

  // TODO CCRA-37242
  const clearErrors = useCallback(() => {
    form.clearErrors(name);
  }, [form.clearErrors]);

  // TODO CCRA-37242
  useEffect(() => {
    if (isDirty) {
      trigger(name);
    }
  }, [isDirty]);

  const value = useWatch({ name }) as T;

  return {
    trigger,
    form,
    isValid,
    isDirty,
    isError,
    isNotValid,
    value,
    setValue,
    clearErrors,
    register,
    control: form.control,
  };
}
